import styled, { css } from 'styled-components';
import Icon from '../../../../../../components/Icon';
import { TextField } from '@mui/material';

export const Wrapper = styled.div`
  position: relative;
  min-width: 50px;
  border: 1px solid var(--transparent-button);
  border-radius: 4px;
  margin-bottom: 0;
  transition: all 0.2s;
  flex: 1;

  ${({ isOpen }) =>
    isOpen
      ? css`
          border-color: var(--white);
        `
      : css``}
`;

export const StyledTextField = styled(TextField)`

  & input {
    color: var(--white);
    cursor: pointer;
  }
  
  & label {
    color: var(--white);
    background-color: var(--luft-secondary);
    padding: 0 4px;
  }

  & svg {
    color: var(--transparent-button);
  }

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }

`;

export const LabelContent = styled.div`
  width: 100%;
  height: 38px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 8px;
  cursor: pointer;
`;

export const Label = styled.span`
  font-size: 14px;
  color: var(--white);
  font-family: 'Work Sans';
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ isOpen }) =>
    isOpen
      ? css`
          color: var(--luft-secondary);
        `
      : css``}
`;

export const LabelIcon = styled(Icon)`
  font-size: 24px;
  transition: all 0.4s;
  color: var(--white);
  position: absolute;
  right: 8px;
  top: 6px;
  cursor: pointer;
  z-index: 2;

  ${({ isOpen }) =>
    isOpen
      ? css`
          transform: rotate(180deg);
        `
      : css``}
`;

export const Dropdown = styled.div`
  position: absolute;
  z-index: 2;

  background-color: var(--white);
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.2), 0px 8px 10px rgba(0, 0, 0, 0.14),
    0px 3px 14px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 16px 0 8px 0;

  min-width: 335px;
  max-width: 360px;

  transition: all 0.2s;
  opacity: 0;
  /* top: 184px; */

  ${({ isOpen }) =>
    isOpen
      ? css`
          top: 45px;
          opacity: 1;
        `
      : css``}

  ${({ alignDropdownRight }) =>
    alignDropdownRight &&
    css`
      right: 0;
    `}
`;
